import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./returnedList.module.scss";
import { mainActions } from "../../../_store/actions/main.actions";
import ReturnedTable from "../returnedTable";
import SearchBar from "../../searchBar";
import useDebounce from "./../../../_utils/debounce";
import { termRegex } from "../../../_utils/utils";
import Pagination from "../../pagination";
import t from "../../../_config/constants";
const ReturnedList = () => {
  const store = useSelector((state) => state);
  const [containers, setContainers] = useState([]);
  const dispatch = useDispatch();
  const [loadingData, setLoadingData] = useState(true);
  const [update, setUpdate] = useState(1);
  const [containerTypes, setContainerTypes] = useState([]);
  const [filterData, setFilterData] = useState({
    searchTerm: "",
    selectedValue: "",
  });
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [numberOfReports, setNumberOfReports] = useState(0);
  const debouncedSearchTerm = useDebounce(filterData.searchTerm, 500);
  useEffect(() => {
    setPageNumber(0);
    const fetchAllContainerTypes = async (regionId) => {
      let filter = [];
      if (regionId && regionId !== "*") {
        filter.push({ regionId: regionId });
      }
      let data = await dispatch(
        mainActions.run("data", "containerType", "all", { filter })
      );
      if (data) setContainerTypes(data);
    };
    if (store.auth && store.auth.user && store.auth.user.regionId) {
      fetchAllContainerTypes(store.auth.user.regionId);
    }
  }, [store.auth && store.auth.user]);
  const getContainers = async (
    term,
    ids,
    pageNumber,
    sortConfig = { createdAt: -1 }
  ) => {
    setLoadingData(true);
    let filter = [{ containerTypeId: { $in: ids } }, { state: "location" }];
    if (term) {
      filter.push({
        $or: [{ name: { $regex: `${termRegex(term)}`, $options: "i" } }],
      });
    }
    let data = await dispatch(
      mainActions.run("data", "container", "page", {
        filter,
        pageSize,
        pageNumber,
        sort: sortConfig,
      })
    );
    if (!data) data = { rows: [], total: 0 };

    setContainers(data.rows);
    setNumberOfReports(data.total);
    setLoadingData(false);
  };
  const onUpdate = () => setUpdate(update === 1 ? 2 : 1);
  useEffect(() => {
    setPageNumber(0);
  }, [debouncedSearchTerm]);
  useEffect(() => {
    if (containerTypes) {
      let ids = containerTypes.map((item) => item._id);
      getContainers(debouncedSearchTerm, ids, pageNumber);
    }
  }, [debouncedSearchTerm, update, containerTypes, pageNumber]);
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFilterData((prevState) => ({ ...prevState, [name]: value }));
  };
  const onPageChange = (page) => {
    setPageNumber(page.selected);
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <SearchBar
          customClass="transactionSearch"
          placeholder={t.report.text_search_container}
          name="searchTerm"
          value={filterData.searchTerm}
          onChange={handleChange}
          disabled={loadingData}
        />
      </div>
      <ReturnedTable
        containers={containers}
        loadingData={loadingData}
        onUpdate={onUpdate}
      />
      <div className={styles.pagination}>
        <Pagination
          handlePageClick={onPageChange}
          pageCount={Math.ceil(numberOfReports / pageSize)}
          forcePage={pageNumber}
          loading={loadingData}
        />
      </div>
    </div>
  );
};

export default ReturnedList;
